import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Cargamos los plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatoHoraSegunZona = ({hora, format = 'HH :mm:a'}) => {

    const userTimezone = dayjs.tz.guess();

    return dayjs(hora).tz(userTimezone).format(format);

}